module.exports = __webpack_public_path__ + "2d78caea0f1a1502ec86e39ee4f770d6.png";